import jqRequest from '../jqRequest'
import answerUrls from '../urls/answer'

export default {
  // 获取问卷详情
  getQuestionnaireDetail(data){
    return jqRequest.requestWithToken(answerUrls.getQuestionnaireDetail, data);
  },
  // 获取问卷详情 H5
  getQuestionnaireDetailForH5(data){
    return jqRequest.requestWithToken(answerUrls.getQuestionnaireDetailForH5, data);
  },
  // 获取问卷题目
  getQuestionnaireSubjects(data) {
    return jqRequest.requestWithToken(answerUrls.getQuestionnaireSubjects, data);
  },
  // 保存答卷
  addQuestionAnswer(data) {
    return jqRequest.requestWithToken(answerUrls.addQuestionAnswer, data);
  },
}